/**
 * Canonical brand/manufacturer slug derivation.
 *
 * Three call sites derived this identically by hand (`createWatchBrand`,
 * `deriveManufacturerSlug`, and `generateBrandId` in PendingReferenceEditor);
 * they all delegate here now so the rules can only drift on purpose.
 *
 * Hyphens are preserved: an input that has already been slugged
 * (`richard-mille`) or a genuinely hyphenated name (`Jaeger-LeCoultre`) must
 * round-trip rather than collapse to `richardmille` / `jaegerlecoultre`.
 * Accented characters are still stripped, not folded — `Glashütte` has always
 * become `glashtte` and existing docs are keyed on that.
 */
export function deriveBrandSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // strip non-alphanumeric, keeping hyphens (drops accented chars like ü)
    .replace(/\s+/g, '-') // spaces → hyphens
    .replace(/^-|-$/g, '');
}
